export enum QuickJumps {
  steps = 'steps',
  chapters = 'chapters',
  disabled = 'disabled'
}

import Vue from 'vue';
import Component from 'vue-class-component';
import TButton from '@/lib/form/button/Button.vue';
import TubeLabel from '@/lib/form/label/Label.vue';
import TInput from '@/lib/form/input/Input.vue';
import { Watch } from 'vue-property-decorator';
declare let PARTNER_MODE: boolean;

@Component({
  name: 'player-controls-mixin',
  props: [
    'duration',
    'currentTime',
    'status',
    'videoVolume',
    'muted',
    'mode',
    'steps',
    'chapters',
    'quickJump',
    'playbackSpeed',
    'slide',
    'simple',
    'slideModeEnabled',
    'caption',
    'levels',
    'level',
    'subtitleTracks',
    'initialSubtitleVisibility',
    'removeTrainnBranding',
    'trainnBrandingMode',
    'showMillis',
    'subtitleMode',
    'hideControls',
    'templateType',
    'forceShowPopover'
  ],
  components: {
    TButton,
    TubeLabel,
    TInput
  }
})
export default class PlayerControlsMixin extends Vue {
  private volume = 0;
  private pipEnabled = true;
  private timerId!: any;
  private showCaption = false;
  private playbackRate = 1;
  private playbackRates!: number[];
  private showPopover = false;
  private showLevelsPopover = false;
  private showPlaybackPopover = false;
  private showChaptersPopover =false;
  private showTranscriptPopover =false;
  private subtitleLanguage = '';
  private partnerMode = PARTNER_MODE;
  showMillis!: boolean;
  videoVolume!: number;
  duration!: number;
  currentTime!: number;
  status!: string;
  muted!: boolean;
  mode!: string;
  subtitleTracks!: any[];
  initialSubtitleVisibility!: boolean;
  steps!: any;
  chapters!: any;
  quickJump!: string;
  playbackSpeed!: string;
  subtitleMode!: string;
  hideControls!: boolean;
  templateType!: string;

  beforeCreate() {
    this.playbackRates = [0.5, 0.7, 1, 1.2, 1.5, 1.7, 2];
  }

  mounted() {
    this.setDefaultPlaybackSpeed(this.playbackSpeed);
    this.volume = this.videoVolume;
    if (!('pictureInPictureEnabled' in document)) {
      this.pipEnabled = false;
    }
    window.addEventListener('keydown', this.keyboardShortcuts);
    document.addEventListener('click', this.hidePopover);
    document.addEventListener('click', this.hideLevelsPopover);
    this.showCaption = this.subtitleLanguage = (this.initialSubtitleVisibility && this.canShowSubtitles && this.canAutoSelectSubtitle && !this.$isEmpty(this.subtitleTracks) && this.subtitleTracks[0].lang) || '';
    if (!this.canAutoSelectSubtitle) {
      this.$emit('setSubtitle', '');
    }
    this.$root.$on('close-player-controls', this.resetControls);
  }

  get isChapter() {
    return this.quickJump == QuickJumps.chapters;
  }

  get quickJumpSteps() {
    if (this.quickJump == QuickJumps.disabled) {
      return;
    }
    if (
      this.quickJump == QuickJumps.chapters &&
      !this.$isEmpty(this.chapters)
    ) {
      return this.chapters;
    }
    return this.steps;
  }

  get width(): string | false {
    if (!this.duration || !this.currentTime) {
      return '0';
    }
    return `${(this.currentTime / this.duration!) * 100}%`;
  }

  get label() {
    return 'sumana';
  }

  get isPaused() {
    return this.status == 'paused';
  }

  get isEnded() {
    return this.status == 'ended';
  }

  get formattedCurrentTime() {
    return this.$msToTime(this.currentTime * 1000, this.showMillis);
  }

  get formattedDuration() {
    return this.$msToTime(this.duration * 1000);
  }

  get isMuted() {
    return this.volume == 0 || this.muted;
  }

  get volumelow() {
    return this.volume > 0 && this.volume < 0.5;
  }

  get isFullScreen() {
    return this.mode == 'fullscreen';
  }

  get canShowSubtitles() {
    if (this.subtitleMode) {
      return this.subtitleMode != 'disabled'
    }
    else {
      return !this.$isEmpty(this.subtitleTracks)
    }
  }

  get canAutoSelectSubtitle() {
    if (this.subtitleMode) {
      return this.subtitleMode == 'auto_show'
    }
    else {
      return !this.$isEmpty(this.subtitleTracks)
    }
  }

  get isPopoverShown() {
    return (
      this.showPopover ||
      this.showLevelsPopover ||
      this.showPlaybackPopover ||
      this.showChaptersPopover ||
      this.showTranscriptPopover
    );
  }

  get showFullscreenControls(){
    return (this.templateType == 'manual_upload' || this.templateType == 'v2' )
  }

  convertStringToFloat(value: string) {
    return parseFloat(
      parseFloat(value)
        .toFixed(1)
        .replace(/\.?0*$/, '')
    );
  }

  showReadableTime(timeInSeconds){
    return this.$msToTime(timeInSeconds * 1000, this.showMillis)
  }

  setDefaultPlaybackSpeed(playbackSpeed: string) {
    if (!playbackSpeed) {
      return;
    }
    this.playbackRate = this.convertStringToFloat(playbackSpeed);
    this.$emit('playbackRate', playbackSpeed);
  }

  showSubtitleTrackOptions() {
    document.removeEventListener('click', this.hidePopover);
    this.showPopover = !this.showPopover;
    if (!this.showPopover) {
      return;
    }
    window.setTimeout(() => {
      document.addEventListener('click', this.hidePopover);
    });
  }

  showLevels() {
    document.removeEventListener('click', this.hideLevelsPopover);
    this.showLevelsPopover = !this.showLevelsPopover;
    if (!this.showLevelsPopover) {
      return;
    }
    window.setTimeout(() => {
      document.addEventListener('click', this.hideLevelsPopover);
    });
  }

  showChapters() {
    document.removeEventListener('click', this.hideChaptersPopover);
    this.showChaptersPopover = !this.showChaptersPopover;
    if (!this.showChaptersPopover) {
      return;
    }
    window.setTimeout(() => {
      document.addEventListener('click', this.hideChaptersPopover);
    });
  }

  showTranscripts() {
    document.removeEventListener('click', this.hideTranscriptPopover);
    this.showTranscriptPopover = !this.showTranscriptPopover;
    if (!this.showTranscriptPopover) {
      return;
    }
    window.setTimeout(() => {
      document.addEventListener('click', this.hideTranscriptPopover);
    });
  }

  showPlaybackRates() {
    document.removeEventListener('click', this.hidePlaybackPopover);
    this.showPlaybackPopover = !this.showPlaybackPopover;
    if (!this.showPlaybackPopover) {
      return;
    }
    window.setTimeout(() => {
      document.addEventListener('click', this.hidePlaybackPopover);
    });
  }

  hidePopover(event) {
    if (
      event &&
      event.target &&
      event.target.closest('.t-player__subtitle-control')
    ) {
      return;
    }
    this.showPopover = false;
  }

  hideLevelsPopover(event) {
    if (
      event &&
      event.target &&
      event.target.closest('.t-player__quality-control')
    ) {
      return;
    }
    this.showLevelsPopover = false;
  }

  hidePlaybackPopover(event) {
    if (
      event &&
      event.target &&
      event.target.closest('.t-player__playback-control')
    ) {
      return;
    }
    this.showPlaybackPopover = false;
  }

  hideChaptersPopover(event) {
    if (
      event &&
      event.target &&
      event.target.closest('.t-player__chapters-control')
    ) {
      return;
    }
    this.showChaptersPopover = false;
  }

  hideTranscriptPopover(event) {
    if (
      event &&
      event.target &&
      event.target.closest('.t-player__transcript-control')
    ) {
      return;
    }
    this.showTranscriptPopover = false;
  }

  setPlaybackSpeed(index) {
    this.playbackRate = this.playbackRates[index];
    this.$emit('playbackRate', this.playbackRate);
    this.$nextTick(() => {
      this.showPlaybackPopover = false;
    });
  }

  setSubtitle(s) {
    this.$emit('setSubtitle', s);
    this.subtitleLanguage = (s && s.lang) || '';
    this.$nextTick(() => {
      this.showPopover = false;
    });
  }

  setLevel(l) {
    this.$emit('setLevel', l);
    this.$nextTick(() => {
      this.showLevelsPopover = false;
    });
  }

  toggleCaption() {
    this.showCaption = !this.showCaption;
    this.subtitleLanguage = this.showCaption
      ? !this.$isEmpty(this.subtitleTracks) && this.subtitleTracks[0].lang
      : '';
    this.$emit('caption', this.showCaption);
  }

  @Watch('videoVolume')
  resyncVolume() {
    this.volume = this.videoVolume;
  }

  @Watch('volume')
  onVolumeUpdated() {
    this.$emit('volume', this.volume);
  }

  @Watch('playbackSpeed')
  updatePlaybackSpeed() {
    this.setDefaultPlaybackSpeed(this.playbackSpeed);
  }

  @Watch('isPopoverShown')
  onPopoverShowUpdated() {
    this.$emit('popoverShown', this.isPopoverShown)
  }

  resetControls() {
    this.showPopover = false;
    this.showLevelsPopover = false;
    this.showPlaybackPopover = false;
    this.showChaptersPopover = false;
    this.showTranscriptPopover = false;
  }

  step(time): string | false {
    if (!this.duration || !time) {
      return '0';
    }
    return `${(time / this.duration!) * 100}%`;
  }

  stepWidth(step) {
    if (this.quickJump != 'chapters' || this.$isEmpty(this.quickJumpSteps)) {
      return;
    }
    const index = this.quickJumpSteps.indexOf(step);
    const itemLeft = (step.startTime / this.duration!) * 100;
    if (index < this.quickJumpSteps.length - 1) {
      const next = this.quickJumpSteps[index + 1];
      const nextItemLeft = (next.startTime / this.duration!) * 100;
      return `${nextItemLeft - itemLeft}%`;
    }
    return `${100 - itemLeft}%`;
  }

  play() {
    this.$emit('play');
  }

  pause() {
    this.$emit('pause');
  }

  enterSlideMode() {
    this.$emit('enterSlideMode');
  }

  seek(event) {
    if (!this.duration) {
      return;
    }
    const slider = this.$refs.slider as HTMLElement;
    const rect = slider.getBoundingClientRect();
    const x = event.clientX - rect.left > 0 ? event.clientX - rect.left : 0;
    let seekTime = (x / slider.clientWidth) * this.duration!;
    seekTime = seekTime < this.duration ? seekTime : this.duration;
    this.$emit('seek', seekTime);
  }

  mute() {
    this.$emit('mute');
  }

  unmute() {
    this.$emit('unmute');
  }

  enterFullScreen() {
    this.$emit('fullscreen');
  }

  exitFullScreen() {
    this.$emit('defaultscreen');
  }

  exitSlideMode() {
    this.$emit('exitSlideMode');
  }

  togglePip() {
    this.$emit('togglePip');
  }

  debounce(func, delay) {
    clearTimeout(this.timerId);
    this.timerId = setTimeout(func, delay);
  }

  keyboardShortcuts(event) {
    if (
      event.target.closest('.t-tiptap') ||
      event.target.closest('.title-modal') ||
      event.target.closest('.t-input') ||
      event.target.closest('.t-textarea__control') || 
      event.target.closest('.t-input__control')
    ) {
      return;
    }
    const { key } = event;
    switch (key) {
      case 'k':
      case ' ':
        this.isPaused || this.isEnded ? this.play() : this.pause();
        event.stopPropagation();
        event.preventDefault();
        break;
      case 'm':
        this.muted ? this.unmute() : this.mute();
        break;
      case 'f':
        this.isFullScreen ? this.exitFullScreen() : this.enterFullScreen();
        break;
      case 'p':
        // this.togglePip();
        break;
      case 'ArrowRight':
        // this.debounce(() => {
        this.$emit('forward');
        // }, 2000);
        break;
      case 'ArrowLeft':
        // this.debounce(() => {
        this.$emit('backward');
        // }, 2000);
        break;
    }
  }

  mousedown() {
    document.addEventListener('mousemove', this.seek);
  }

  mouseup() {
    document.removeEventListener('mousemove', this.seek);
  }

  destroyed() {
    window.removeEventListener('keydown', this.keyboardShortcuts);
    document.removeEventListener('click', this.hidePopover);
    document.removeEventListener('click', this.hideLevelsPopover);
    document.removeEventListener('mousemove', this.seek);
    this.$root.$off('close-player-controls', this.resetControls);
  }

  onChapterSelect(seekTime){
    if (seekTime >= 0 && seekTime <= this.duration) {
      this.$emit('seek', seekTime);
    }
  }
}
